import { render, staticRenderFns } from "./NbTable.vue?vue&type=template&id=48736e25&"
import script from "./NbTable.vue?vue&type=script&lang=js&"
export * from "./NbTable.vue?vue&type=script&lang=js&"
import style0 from "./NbTable.vue?vue&type=style&index=0&id=48736e25&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports